import styled from 'styled-components';
export var FilterStringWrapper = styled.div.withConfig({
  displayName: "FilterStringstyles__FilterStringWrapper",
  componentId: "keen-query-creator__sc-17f364o-0"
})(["&&&{width:200px;}"]);